import { render, staticRenderFns } from "./multiple_heading_with_content.vue?vue&type=template&id=12d0a174&scoped=true&"
import script from "./multiple_heading_with_content.vue?vue&type=script&lang=js&"
export * from "./multiple_heading_with_content.vue?vue&type=script&lang=js&"
import style0 from "./multiple_heading_with_content.vue?vue&type=style&index=0&id=12d0a174&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d0a174",
  null
  
)

export default component.exports